/* Nibbo UGC wall — click-to-load video embeds.
 *
 * Progressive enhancement, same shape as nibbo-cart.js. The facade this file
 * touches already works without it: it's a real <a href="video_url"> to the
 * creator's public TikTok/Instagram page. If this file fails to load, or JS
 * is off, a visitor still reaches the video — just on the platform itself.
 *
 * This is the entire Quebec Law 25 s.8.1 mechanism for this section: nothing
 * from TikTok (script, cookie, request) touches the page until the click
 * handler below fires. The facade — a thumbnail served from TikTok's own CDN
 * via a plain <img>, no tracking pixel — is the prior notice; the click is
 * the activation gesture the law requires before any identification/
 * profiling technology loads.
 */
(function () {
  'use strict';

  var tiles = document.querySelectorAll('.ugc-wall__tile');
  if (!tiles.length) return;

  var scriptLoaded = false;
  var scriptLoading = false;
  var pendingCallbacks = [];
  var openTile = null;

  function loadTikTokEmbedScript(cb) {
    if (scriptLoaded) { cb(); return; }
    pendingCallbacks.push(cb);
    if (scriptLoading) return;
    scriptLoading = true;
    var s = document.createElement('script');
    s.src = 'https://www.tiktok.com/embed.js';
    s.async = true;
    s.onload = function () {
      scriptLoaded = true;
      pendingCallbacks.forEach(function (fn) { fn(); });
      pendingCallbacks = [];
    };
    document.body.appendChild(s);
  }

  function restore(tile) {
    var embed = tile.querySelector('.ugc-wall__embed');
    if (embed && embed._facade) {
      tile.replaceChild(embed._facade, embed);
      embed._facade.focus();
    }
    if (openTile === tile) openTile = null;
  }

  tiles.forEach(function (tile) {
    var facade = tile.querySelector('[data-ugc-play]');
    var src = tile.querySelector('.ugc-wall__embed-src');
    // No oembed captured yet for this tile (e.g. an Instagram block, or a
    // TikTok row the curator hasn't finished vetting) — leave it as a plain
    // facade that link-outs on click. Nothing to wire up.
    if (!facade || !src) return;

    facade.addEventListener('click', function (e) {
      e.preventDefault();
      if (openTile && openTile !== tile) restore(openTile);

      var mount = document.createElement('div');
      mount.className = 'ugc-wall__embed';
      mount.setAttribute('tabindex', '-1');
      mount.appendChild(src.content.cloneNode(true));
      mount._facade = facade;

      tile.replaceChild(mount, facade);
      openTile = tile;
      mount.focus();

      // TikTok's embed.js scans the DOM for .tiktok-embed on load and again
      // via its own mutation observer — loading it now, never before, is the
      // whole point of the click-to-load gate.
      loadTikTokEmbedScript(function () {});
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openTile) restore(openTile);
  });
})();
